import React, { useState } from "react";
import styles from "./settings.module.css";

const Settings = () => {
    const [theme, setTheme] = useState("light");
    const [notifications, setNotifications] = useState({
        email: true,
        sms: false,
    });

    const handleThemeChange = (e) => setTheme(e.target.value);

    const handleNotificationChange = (e) => {
        const { name, checked } = e.target;
        setNotifications((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleSaveSettings = () => {
        // Save settings (e.g., send data to the backend)
        console.log("Settings saved:", { theme, notifications });
    };

    return (
        <div className={styles.settingsContainer}>
            <h1>Settings</h1>

            {/* Profile Settings */}
            <section className={styles.section}>
                <h2>Profile Settings</h2>
                <div className={styles.formGroup}>
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" placeholder="Enter your name" />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" placeholder="Enter your email" />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="phone">Phone</label>
                    <input type="tel" id="phone" placeholder="Enter your phone number" />
                </div>
            </section>

            {/* Security Settings */}
            <section className={styles.section}>
                <h2>Password & Security</h2>
                <button className={styles.button}>Change Password</button>
                <div className={styles.formGroup}>
                    <label>
                        <input type="checkbox" /> Enable Two-Factor Authentication
                    </label>
                </div>
            </section>

            {/* Notification Preferences */}
            <section className={styles.section}>
                <h2>Notification Preferences</h2>
                <div className={styles.formGroup}>
                    <label>
                        <input
                            type="checkbox"
                            name="email"
                            checked={notifications.email}
                            onChange={handleNotificationChange}
                        />{" "}
                        Email Notifications
                    </label>
                </div>
                <div className={styles.formGroup}>
                    <label>
                        <input
                            type="checkbox"
                            name="sms"
                            checked={notifications.sms}
                            onChange={handleNotificationChange}
                        />{" "}
                        SMS Notifications
                    </label>
                </div>
            </section>

            {/* Preferences */}
            <section className={styles.section}>
                <h2>Preferences</h2>
                <div className={styles.formGroup}>
                    <label>Theme</label>
                    <select value={theme} onChange={handleThemeChange}>
                        <option value="light">Light</option>
                        <option value="dark">Dark</option>
                    </select>
                </div>
            </section>

            {/* Save Button */}
            <div className={styles.saveButtonContainer}>
                <button className={styles.button} onClick={handleSaveSettings}>
                    Save Settings
                </button>
            </div>
        </div>
    );
};

export default Settings;
